(function() {

	angular
		.module('ngmvac')
		.directive('starRate', StarRate);

	function StarRate() {

		var expresiones = [
		  	/(\d)(EST|LUX)/,
		  	/(H)(\d)_5/,
		  	/((H)(\d)S)|(SUP)/
		];

		function compare(cadena) {
		  	for (var index = 0; index < expresiones.length; index++) {
		    	var re = new RegExp(expresiones[index]);
		    	if (re.test(cadena)) {
		      		return index;
		    	}
		  	}
		  	return 3;
		}

		return {
			restrict: 'EA',
			template: [
				'<ul class="star-rating text-stars" style="{{styleColor}}">' +
					'<li ng-repeat="star in completeStars" class="stars" ng-class="star.class">' +
						'<i class="fa fa-star"></i>'+
					'</li>' +
					'<li ng-repeat="star in halfStars" class="stars" ng-class="star.class">' +
						'<i class="fa fa-star-half-alt"></i>'+
					'</li>' +
					'<li ng-repeat="star in outStars" class="stars" ng-class="star.class">' +
						'<i class="fa fa-star-o"></i>'+
					'</li>' +
				'</ul>' +
				'<span class="star-rate-text" ng-if="completeStars.length<1">{{categoryName}}</span>'
			].join(''),
			scope: {
				ratingValue: '=ngModel',
				max: '=?',
				categoryName: '=',
				optional: '=?',
				color: '=?'
			},
			link: function(scope, element, attrs) {
				scope.completeStars = [];
				scope.halfStars = [];
				scope.outStars = [];
				scope.styleColor = "";

				if( scope.max == undefined ) {
					scope.max = 5;
				}

				if (scope.color != undefined) {
					scope.styleColor = "color: "+scope.color;
				}
				
				if (scope.ratingValue == undefined ){
					ratingValue = scope.optional;
				}else{
					ratingValue = scope.ratingValue;
				}
				var index = compare(ratingValue);
				

				switch( index ) {
					case 0:
						var re = expresiones[index].exec(ratingValue);
						var _class = re[2];
						for( var i = 0; i < re[1]; i++ ) {
							scope.completeStars.push({
								'class': _class
							});
						}
						for( var _i = re[1]; _i < (scope.max); _i++ ) {
							scope.outStars.push({
								'class': _class
							});
						}
					break;
					case 1:
						var re = expresiones[index].exec(ratingValue);
						for( var i = 0; i < re[2]; i++ ) {
							scope.completeStars.push({
								'class': ''
							});
						}
						scope.halfStars.push({
							'class': ''
						});
						for( var _i = re[2]; _i < (scope.max - 1); _i++ ) {
							scope.outStars.push({
								'class': ''
							});
						}
					break;
					case 2:
						var re = expresiones[index].exec(ratingValue);
						if( re[2] === undefined ) 
							re[2] = 4;

						for( var i = 0; i < re[2]; i++ ) {
							scope.completeStars.push({
								'class': 'superior'
							});
						}
						for( var _i = re[2]; _i < (scope.max); _i++ ) {
							scope.outStars.push({
								'class': 'superior'
							});
						}
					break;
					default:

				}
			}
		}
	}

})();
